import Axios from "@/plugins/Axios";

export class PlanosBimestraisService {
  async planoBimestral(gestaoDeAulaId, bimestre, disciplinaId) {
    const response = await Axios().get(
      `planos/plano-bimestral/${gestaoDeAulaId}/${bimestre}/${disciplinaId}`
    );
    return response.data;
  }

  async planoMensal(gestaoDeAulaId, disciplinaId, mes) {
    const response = await Axios().get(
      `planos/plano-mensal/${gestaoDeAulaId}/${disciplinaId}/${mes}`
    );
    return response.data;
  }

  async planoMensalInfantil(gestaoDeAulaId, mes) {
    const response = await Axios().get(`planos/plano-mensal-infantil/${gestaoDeAulaId}/${mes}`);
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post("planos/criar-plano-bimestral", {
      plano,
    });
    return response.data;
  }

  async planoMensalCreateOrUpdate(plano) {
    const response = await Axios().post("planos/plano-mensal/create-or-update", {
      plano,
    });
    return response.data;
  }

  async planoMensalExportar(plano) {
    const response = await Axios().post("planos/plano-mensal/exportar", {
      plano,
    });
    return response.data;
  }

  async planoMensalInfantilCreateOrUpdate(plano) {
    const response = await Axios().post("planos/plano-mensal-infantil/create-or-update", {
      plano,
    });
    return response.data;
  }

  async planoBimestralInfanil(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `planos/plano-bimestral-infantil/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }

  async createOrUpdateInfantil(plano) {
    const response = await Axios().post("planos/criar-plano-bimestral-infantil", {
      plano,
    });
    return response.data;
  }

   async planoMensalPDF(gestaoDeAulaId, disciplina_id, mes_id, file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await Axios().post(
          `planos/plano-mensal/uploadPdf/${gestaoDeAulaId}/${disciplina_id}/${mes_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const resultData = response.data ?? response;
        if (resultData) {
          return resultData;
        }
        return null;
      } catch (error) {
        throw error;
      }
    }

    async downloadPlanoMensal(gestaoDeAulaId, disciplina_id, mes_id) {
      const response = await Axios()
        .get(`planos/plano-mensal/downloadPdf/${gestaoDeAulaId}/${disciplina_id}/${mes_id}`, {
          responseType: "blob",
        })
        .then((response) => {
          const a = document.createElement("a");
          a.href = window.URL.createObjectURL(response.data);
          window.open(a.href);
        });

      return response;
    }
}
export default new PlanosBimestraisService();
